export const getDestination = (state) => state.destination?.destination;
export const getDestinationStatus = (state) => state.destination.destination?.status;
export const getDestinationError = (state) => state.destination.destination?.error;

export const getMerchandise = (state) => state.destination?.merchandise;
export const getMerchandiseStatus = (state) => state.destination.merchandise?.status;
export const getMerchandiseError = (state) => state.destination.merchandise?.error;
